import { render, staticRenderFns } from "./KeyIssue.vue?vue&type=template&id=3944cea3&"
import script from "./KeyIssue.vue?vue&type=script&lang=js&"
export * from "./KeyIssue.vue?vue&type=script&lang=js&"
import style0 from "./KeyIssue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports